<template>
  <div class="fullheight">
    <eco-table
      ref="identityTable"
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props="name,alias"
      :show-export="false"
      :defaultSorter="[{ property: 'CREATE_TIME_', direction: 'DESC' }]"
    >
      <template v-slot:toolbar>
        <el-button type="primary" size="small" @click="handleCommand({ command: 'add' })">添加</el-button>
        <fe-delete-button class="marginLeft16" :url="identityDeleteUrl" :htTable="$refs.identityTable">删除</fe-delete-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="name" label="名称" width="300" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <el-link @click="handleCommand({ row: row, command: 'edit' })" type="primary">{{ row.name }}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="alias" label="别名" :sortable="true" />
        <eco-table-column
          prop="genType"
          label="生成类型"
          :filters="[
            { text: '递增', value: 0 },
            { text: '每天生成', value: 1 },
            { text: '每月生成', value: 2 },
            { text: '每年生成', value: 3 }
          ]"
        >
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.genType === 0">递增</el-tag>
            <el-tag type="primary" v-if="row.genType === 1">每天生成</el-tag>
            <el-tag type="warning" v-if="row.genType === 2">每月生成</el-tag>
            <el-tag type="danger" v-if="row.genType === 3">每年生成</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="regulation" label="规则" sortable />
        <eco-table-column prop="noLength" label="长度" sortable />
        <eco-table-column width="150" label="操作">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleCommand({ row: row, command: 'list' })">查看</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <el-dialog width="50%" :title="identiyTitle" :visible="dialogVisible" :before-close="handleClose" append-to-body>
      <el-form :disabled="identityDisabled" v-model="identity" data-vv-scope="editIdentityForm">
        <eco-form-item label="流水号名称" prop="name" label-width="120px" class="identity-input-width">
          <eco-input v-model="identity.name" autocomplete="off" :validate="{ required: true }" placeholder="请输入名称"></eco-input>
        </eco-form-item>
        <eco-form-item label="流水号别名" prop="alias" label-width="120px" class="identity-input-width">
          <eco-input
            v-model="identity.alias"
            v-pinyin="identity.name"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true }"
            placeholder="请输入别名"
            :disabled="identity.id ? true : false"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="流水号规则" label-width="120px" class="identity-item-bottom identity-input-width">
          <eco-input width="100%" v-model="identity.regulation" :validate="{ required: true }" placeholder="请输入流水号规则" />
        </eco-form-item>
        <eco-form-item label label-width="120px" class="identity-item-bottom">
          <ul>
            <li>{yyyy}{MM}{dd}{NO}</li>
            <li>{yyyy}:表示年份</li>
            <li>{yy}:表示年份</li>
            <li>{MM} :表示月份，如果月份小于10，则加零补齐，如1月份表示为01。</li>
            <li>{mm} :表示月份，月份不补齐，如1月份表示为1。</li>
            <li>{DD} :表示日，如果小于10号，则加零补齐，如1号表示为01。</li>
            <li>{dd} :表示日，日期不补齐，如1号表示为1。</li>
            <li>{NO} :表示流水号，前面补零。</li>
            <li>{no} :表示流水号，后面补零。</li>
            <li>{xx.xxx} :表示表单中的字符，xx为数据建模实体名称，xxx为字段名称。例如：{student.name}</li>
          </ul>
        </eco-form-item>
        <eco-form-item label="生成类型" label-width="120px" class="identity-item-bottom identity-input-width">
          <eco-radio :validate="{ required: true }" v-model="identity.genType" :options="genTypes" />
        </eco-form-item>
        <eco-form-item label label-width="120px" class="identity-item-bottom">
          <ul>
            <li>1.每天生成。每天从初始值开始计数。</li>
            <li>2.递增，流水号一直增加。</li>
          </ul>
        </eco-form-item>
        <eco-form-item label="流水号长度" label-width="120px" class="identity-item-bottom identity-input-width">
          <eco-input :validate="'required: true|regex:^[0-9]*$,只能输入数字'" v-model="identity.noLength" placeholder="请输入流水号长度" />
        </eco-form-item>
        <eco-form-item label label-width="120px" class="identity-item-bottom">
          <ul>
            <li>这个长度表示当前流水号的长度数，只包括流水号部分{NO},如果长度为5，当前流水号为5，则在流水号前补4个0，表示为00005。</li>
            <li>{no}如果长度为5，当前流水号为501，则在流水号后面补5个0，表示为50100000。</li>
          </ul>
        </eco-form-item>
        <eco-form-item label="初始值" label-width="120px" class="identity-item-bottom identity-input-width">
          <eco-input :validate="'required: true|regex:^[0-9]*$,只能输入数字'" v-model="identity.initValue" placeholder="请输入初始值" />
        </eco-form-item>
        <eco-form-item label label-width="120px" class="identity-item-bottom">
          <ul>
            <li>这个初始值表示流水号部分{NO}的初始值。如 2015102700001,初始值为1，则流水号部分的初始值为00001</li>
          </ul>
        </eco-form-item>
        <eco-form-item label="步长" label-width="120px" class="identity-item-bottom identity-input-width">
          <eco-input :validate="'required: true|regex:^[0-9]*$,只能输入数字'" v-model="identity.step" placeholder="请输入步长" />
        </eco-form-item>
        <eco-form-item label label-width="120px" class="identity-item-bottom">
          <ul>
            <li>流水号每次递加的数字，默认步长为1。比如步长为2，则每次获取流水号则在原来的基础上加2。</li>
          </ul>
        </eco-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          v-show="!identityDisabled"
          :url="saveIdentityUrl()"
          :model="identity"
          :is-submit="isSubmit"
          :request-method="requestMethod"
          scope-name="editIdentityForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="dialogCancle('dialogVisible')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog width="50%" :title="identiyTitle" :visible="dialogVisibleL" :before-close="handleCloseL" append-to-body>
      <el-form  v-model="identityL" data-vv-scope="editIdentityForm1">
        <eco-form-item label="别名" prop="alias" label-width="120px" class="identity-input-width">
          <eco-input
            v-model="identityL.alias"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入别名"
            disabled
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="流水号固定值" prop="fixedValue" label-width="120px" class="identity-input-width">
          <eco-input
            v-model="identityL.fixedValue"
            :validate="{ required: true}"
            placeholder="请输入流水号固定值"
            :disabled="identityL.id?true:false"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="当前值" prop="curValue" label-width="120px" class="identity-input-width">
          <eco-input
            v-model="identityL.curValue"
            :validate="'required: true|regex:^[0-9]*$,只能输入数字'"
            placeholder="请输入当前值"
          ></eco-input>
        </eco-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          :url="saveIdentityUrlD()"
          :model="identityL"
          :is-submit="isSubmit"
          :request-method="requestMethod"
          scope-name="editIdentityForm1"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveDataL"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="dialogCancle('dialogVisibleL')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-drawer
      class="sideDrawer noButtonAhead"
      destroy-on-close
      :size="drawerSize"
      title="流水号"
      :visible="dialogVisibleD"
      :before-close="handleCloseD"
      close-on-click-modal
      :append-to-body="true"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div style="padding: 20px; height: 100%">
        <eco-table
          v-if="dialogVisibleD"
          @load="loadDataD"
          :data="dataD"
          :pageResult="pageResultD"
          :selection="true"
          :show-export="false"
          :show-custom-column="false"
          :default-querys="[{ property: 'alias', value: this.outObj.alias }]"
          :quick-search-props="[
            { prop: 'fixedValue', label: '流水号固定值' },
            { prop: 'curValue', label: '当前值' }
          ]"
          ref="userRoleTable"
        >
        <template v-slot:toolbar>
          <el-button type="primary" size="small" @click="handleCommand({ command: 'listAdd' })">添加</el-button>
          </template>
          <template>
            <eco-table-column type="index" width="50" align="center" label="序号" />
            <eco-table-column prop="alias" label="别名" :sortable="true" :show-overflow-tooltip="true" />
            <eco-table-column prop="fixedValue" label="流水号固定值" :sortable="true" :show-overflow-tooltip="true" />
            <eco-table-column :sortable="true" :show-overflow-tooltip="true" prop="curValue" label="当前值" />
            <eco-table-column label="操作">
              <template v-slot="{ row }">
                <el-link type="primary" @click="handleCommand({ row: row, command: 'listEdit' })">编辑</el-link>
              </template>
            </eco-table-column>
          </template>
        </eco-table>
      </div>
    </el-drawer>
    <!-- 加载数据 用作编辑流水号和查看流水号-->
    <fe-load-data :url="loadDataUrl" context="portal" @after-load-data="afterLoadData"></fe-load-data>
  </div>
</template>
<script>
import sys from '@/api/portal.js'
import utils from "@/utils.js";

export default {
  name: 'meta-identity',
  components: {},
  data() {
    return {
      drawerSize: '70%',
      identityDisabled: false,
      identiyTitle: '',
      loadDataUrl: '',
      dialogVisible: false,
      outObj: {},
      dialogVisibleD: false,
      dialogVisibleL: false,
      data: [],
      dataD: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      pageResultD: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      isSubmit: true,
      identityL: {
      },
      identity: {
        name: '',
        alias: '',
        regulation: '',
        genType: '',
        noLength: '',
        initValue: '',
        step: ''
      },
      genTypes: [
        { key: 3, value: '每年生成' },
        { key: 2, value: '每月生成' },
        { key: 1, value: '每天生成 ' },
        { key: 0, value: '递增' }
      ]
    }
  },
  computed: {
    requestMethod: function () {
      return 'POST'
    },
    identityDeleteUrl: function () {
      return window.context.portal + '/sys/identity/v1/remove'
    }
  },
  methods: {
    beforeSaveData() {
      this.isSubmit = true
    },
    saveIdentityUrl: function () {
      return window.context.portal + '/sys/identity/v1/save'
    },
    saveIdentityUrlD: function () {
      return window.context.portal + '/sys/identityRecord/v1/save'
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.identityTable.load()
    },
    afterSaveDataL() {
      this.dialogVisibleL = false
      this.$refs.userRoleTable.load()
    },
    afterLoadData(data) {
      // 编辑流水号
      if (this.dialogVisible) {
        this.identity = data
        setTimeout(() => this.$validator.validateAll('editIdentityForm'))
      }
    },
    dialogCancle(dialogVisible) {
      this.loadDataUrl = ''
      this[dialogVisible] = false
      setTimeout(() => (this.identityDisabled = false), 500)
    },
    handleCloseD() {
      this.outObj = {}
      this.dialogVisibleD = false
    },
    handleCloseL() {
      this.dialogVisibleL = false
      this.$refs.userRoleTable.load()
    },
    handleClose() {
      this.loadDataUrl = ''
      this.dialogVisible = false
      setTimeout(() => (this.identityDisabled = false), 500)
    },
    showDialog(row) {
      this.dialogVisible = true
      if (row) {
        this.loadDataUrl = `/sys/identity/v1/getJson?id=${row.id}`
      }
    },
    showDialogD(row) {
      this.dialogVisibleD = true
      if (row) {
        this.outObj = utils.deepClone(row)
      }
    },
    showDialogL(row, state) {
      this.identityL = {}
      if (row) {
        if (state == 'add') {
          delete row.id
          row.fixedValue = row.regulation
        }
        this.identityL = utils.deepClone(row)
      }
      
      this.dialogVisibleL = true
    },
    handleNodeClick(node) {},
    loadData(param, cb) {
      sys
        .getIdentityPageJson(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    loadDataD(param, cb) {
      sys
        .getIdentityPageQuery(param)
        .then((response) => {
          this.dataD = response.rows
          this.pageResultD = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'list':
          this.identiyTitle = '流水号'
          this.showDialogD(params.row)
          break
          listAdd
          case 'listAdd':
          this.identiyTitle = '流水号新增'
          this.showDialogL(this.outObj,'add')
          break
          case 'listEdit':
          this.identiyTitle = '流水号编辑'
          this.showDialogL(params.row,'edit')
          break
        case 'edit':
          this.identiyTitle = '编辑流水号'
          this.showDialog(params.row)
          break
        case 'add':
          this.identity = {
            name: '',
            alias: '',
            regulation: '',
            genType: '',
            noLength: '',
            initValue: '',
            step: ''
          }
          this.identiyTitle = '添加流水号'
          this.showDialog()
          break
        case 'get':
          this.identiyTitle = '查看流水号'
          this.isSubmit = false
          this.identityDisabled = true
          this.showDialog(params.row)
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped>
ul {
  padding: 0px;
  margin: 0px;
}

li {
  list-style-type: none;
}

.identity-item-bottom {
  margin-bottom: 5px;
}

.identity-input-width .inputs {
  width: 100%;
}
</style>
